import { msalInstance } from './auth';
import { API } from './requests';
import Constants from './constants';

export const platformDacAPI = new API(Constants.basePathPlatformDacAPI, msalInstance, [
  Constants.platformCommonScope,
]);

export const platformUsrMgtAPI = new API(Constants.basePathPlatformUsrMgtAPI, msalInstance, [
  Constants.platformCommonScope,
]);

export const platformSupAPI = new API(Constants.basePathPlatformSupAPI, msalInstance, [
  Constants.platformCommonScope,
]);

export const platformSubsAPI = new API(Constants.basePathPlatformSubsAPI, msalInstance, [
  Constants.platformCommonScope,
]);

export const platformAppMgtAPI = new API(Constants.basePathPlatformAppMgtAPI, msalInstance, [
  Constants.platformCommonScope,
]);

export const platformNotificationAPI = new API(Constants.notificationAPI, msalInstance, [
  Constants.platformCommonScope,
]);
